import Preacher from "../DTOs/Preacher";
import ChoirSong from "../DTOs/ChoirSong";

/**
 * Maximum number of autocomplete results to display
 */
export const MAX_AUTOCOMPLETE_RESULTS = 10;

/**
 * Filters preachers based on input text and returns top matches.
 * If no input is provided (or only whitespace), returns the first items.
 * Search is case-insensitive and matches anywhere in "name surname".
 * 
 * @param input - The search text entered by the user
 * @param preachersList - The full list of preachers to filter
 * @returns Top matching preachers (up to MAX_AUTOCOMPLETE_RESULTS)
 */
export function filterPreachers(input: string, allPreachers: Preacher[]): Preacher[] {
    // Archived preachers are never offered (GOD-33).
    const preachersList = allPreachers.filter((p) => !p.archived);
    const normalized = input.trim();
    if (!normalized) {
        return preachersList.slice(0, MAX_AUTOCOMPLETE_RESULTS);
    }
    const searchTerm = normalized.toLowerCase();
    const filtered = preachersList.filter(p => 
        `${p.name} ${p.surname}`.toLowerCase().includes(searchTerm)
    );
    return filtered.slice(0, MAX_AUTOCOMPLETE_RESULTS);
}

/**
 * Filters choir songs based on input text and returns top matches.
 * If no input is provided (or only whitespace), returns the first items.
 * Search is case-insensitive and matches anywhere in the song name.
 * 
 * @param input - The search text entered by the user
 * @param songsList - The full list of choir songs to filter
 * @returns Top matching choir songs (up to MAX_AUTOCOMPLETE_RESULTS)
 */
export function filterChoirSongs(input: string, songsList: ChoirSong[]): ChoirSong[] {
    const normalized = input.trim();
    if (!normalized) {
        return songsList.slice(0, MAX_AUTOCOMPLETE_RESULTS);
    }
    const searchTerm = normalized.toLowerCase();
    // Note: .toString() is needed because ChoirSong.name is typed as String (object wrapper)
    const filtered = songsList.filter(s => 
        s.name.toString().toLowerCase().includes(searchTerm)
    );
    return filtered.slice(0, MAX_AUTOCOMPLETE_RESULTS);
}
